
export default {
  allContacts: (state) => state.contacts
}
